import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import scopeBreadcrumbMixin from '@/components/core/tenant/scopeBreadCrumbMixin';
import cloneDeep from 'lodash/cloneDeep';
import flatten from 'lodash/flatten';
import get from 'lodash/get';
export default {
  name: 'CoreTenantScopesPermissionsList',
  mixins: [scopeBreadcrumbMixin],
  props: {
    userAccess: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: false
    }
  },
  data: function () {
    return {
      scopeDialog: false,
      availableRolesPerScope: {},
      scopeSelectorRoles: [],
      // updated on-the-fly, when a row is selected
      availableRoles: [],
      accessTableExpandedRows: [],
      accessTableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [15, 25, 50, {
          text: this.$i18n_t('Common.all'),
          value: -1
        }]
      },
      accessTableSearch: '',
      isLoadingScopeRoles: false,
      scopeSelectorFormValid: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'inpOutlined', 'inpFilled', 'color', 'UiTheme']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    }),
    accessTableRolesHeaders() {
      return [{
        sortable: false,
        text: this.$i18n_t('Common.id'),
        value: 'id',
        width: 40
      }, {
        sortable: false,
        text: this.$i18n_t('DigitalTwin.DigitalTwin.scope'),
        value: 'name'
      }, {
        sortable: false,
        text: this.$i18n_t('Common.action'),
        align: 'right'
      }];
    },
    selectedScopes() {
      return this.userAccess.filter(access => get(access, 'roles')).map(access => {
        return {
          ...get(access, 'Scope'),
          tenantId: get(access, 'tenantId')
        };
      });
    },
    buttons() {
      return [{
        icon: 'fal fa-question-circle',
        href: `${this.$store.state.app.docsBaseURL}/accounts/`,
        target: '_blank',
        valid: true
      }, {
        title: this.$i18n_t('Common.addNew'),
        icon: 'fal fa-plus',
        action: 'addItem',
        valid: !this.loading
      }];
    }
  },
  watch: {
    scopeDialog() {
      if (this.scopeDialog) {
        this.$nextTick(() => {
          this.$refs['scopeSelectorForm'].validate();
        });
      }
    }
  },
  methods: {
    fetchRoles(scopeId) {
      return ApiService.fetchRoles(scopeId, this.sessionUserId);
    },
    filterRolesForScope(scopeId, lazyLoadRoles = false) {
      if (lazyLoadRoles && !this.availableRolesPerScope[scopeId]) {
        this.isLoadingScopeRoles = true;
        this.fetchRoles(scopeId).then(roles => {
          this.availableRolesPerScope[scopeId] = cloneDeep(roles);
          this.availableRoles = this.availableRolesPerScope[scopeId];
        }).catch(error => {
          console.error('Error loading scope roles', error);
          this.availableRolesPerScope[scopeId] = [];
        }).finally(() => {
          this.isLoadingScopeRoles = false;
        });
      }
      const filteredAccess = this.userAccess.filter(access => {
        return get(access, 'Scope.id') === scopeId;
      });
      const rolesForScope = flatten(filteredAccess.map(access => {
        return get(access, 'roles');
      }).filter(r => r));
      return rolesForScope;
    },
    scopeChosen(scopeId) {
      this.scopeSelectorRoles = this.filterRolesForScope(scopeId).sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    },
    deleteAccess(scopeId) {
      // clear all other access objects for this scope
      let newAccess = this.userAccess.filter(access => {
        return access.scopeId !== scopeId || !access.scopeId;
      });
      this.$emit('updatedUserAccess', newAccess);
    },
    scopeSelectorDialogSave() {
      (this.$refs['scopeAccessSelector'] || {}).emitRoles();
    },
    rolesChosen(roles, scopeId, tenantId) {
      // clear all other access objects for this scope
      let newAccess = this.userAccess.filter(access => {
        return access.scopeId !== scopeId || !access.scopeId;
      });
      // NOTE: might also push an empty roles-array
      // required for matching in ApiService
      newAccess.push({
        tenantId,
        scopeId,
        Scope: {
          id: scopeId
        },
        roles
      });
      this.$emit('updatedUserAccess', newAccess);
      this.scopeSelectorClosed();
    },
    scopeSelectorClosed() {
      this.scopeDialog = false;
    },
    clickedAccessTableRow(item) {
      if (this.accessTableExpandedRows.length === 0 || this.accessTableExpandedRows[0].id !== item.id) {
        this.availableRoles = cloneDeep(this.availableRolesPerScope[item.id]);
        this.accessTableExpandedRows = [item];
      } else {
        this.availableRoles = [];
        this.accessTableExpandedRows = [];
      }
    },
    isPrimaryScope(scopeId) {
      const access = this.userAccess.find(access => {
        return access.scopeId === scopeId;
      });
      return access ? access.primary : false;
    }
  }
};